/* eslint-disable react/jsx-props-no-spreading */
import { Switch } from 'react-router-dom'

import type { Route } from './config'
import Routes from './Routes'

interface RouterProps {
  routes: Route[]
}

const Router = ({ routes }: RouterProps) => (
  <Switch>{routes && routes.map((r) => <Routes key={r.path} {...r} />)}</Switch>
)

export default Router
